<form tabindex="0" >
  <mat-form-field>
    <input #input matInput [(ngModel)]="value" placeholder="{{placeholder | translate}}" [ngModelOptions]="{standalone: true}">
  </mat-form-field>
</form>
